import {axiosInstance} from "@/plugins/axios";
import {Agent} from "@/modules/agent/types";

export async function getAgents() {
  const response = await axiosInstance.get(`agents`);
  return response.data;
}

export async function getAgent(id: string) {
  const response = await axiosInstance.get(`agents/${id}`);
  return response.data;
}

export async function saveAgent(agent: Agent) {
  await axiosInstance.post(`agents`, agent);
}

export async function deleteAgent(id: string) {
  await axiosInstance.delete(`agents/${id}`);
}

export async function updateAgent(agent: Agent) {
  await axiosInstance.put(`agents/${agent.id}`, agent);
}
